import AICalculator from "@/components/AICalculator";
import SEOHead from "@/components/SEOHead";

export default function CalculatorPage() {
  return (
    <>
      <SEOHead
        title="KI-Preisrechner – EasyRohbau | Rohbaukosten berechnen"
        description="Berechnen Sie Ihre Rohbaukosten in 60 Sekunden. KI-gestützte Marktpreisanalyse, regionale Faktoren und Materialindex – kostenlos und unverbindlich."
      />
      <section className="pt-32 pb-12 bg-white blueprint-bg">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16 text-center">
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-[#2873B8] mb-4">KI-Preisrechner</p>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-[#0C2749] tracking-tight max-w-3xl mx-auto" style={{ fontFamily: "Outfit" }}>
            Ihr Rohbau-Preis in <span className="text-[#2873B8]">60 Sekunden.</span>
          </h1>
          <p className="text-slate-600 max-w-2xl mx-auto mt-6">
            Geben Sie wenige Eckdaten ein. Unsere KI analysiert aktuelle Marktpreise, regionale Faktoren und Material­indizes und liefert eine belastbare Indikation – kostenlos und unverbindlich.
          </p>
        </div>
      </section>
      <section className="bg-white pb-24 px-4 md:px-12 lg:px-16">
        <AICalculator compact />
      </section>
    </>
  );
}
